import { TOTAL_MINT } from "./mint";

export const WHITELIST_SHARE_TEXT =
  "Just joined the whitelist to free-mint Warplet Mutants: Aftershock. Massive energy. Be early!\n\nMinting time: 12pm UTC today November 19th @warpletmutants.eth";

export const MINTED_SHARE_TEXT = `I own 1 of the ${TOTAL_MINT} Warplet Mutants: Aftershock, absolutely badass!`;
